import template from 'text!./medical-treatment.html';
import controller from './MedicalTreatmentCtrl';

export default {
    template: template,
    controller: controller,
    bindings: {
        workersComp: '='
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/wc/components/MedicalTreatment/MedicalTreatmentComponent.js
// module id = 1596
// module chunks = 0